import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get authorization code from query params (Google sends ?code=...)
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (!code) {
        navigate('/');
        return;
      }

      try {
        const redirectUri = window.location.origin + '/auth/callback';

        const response = await fetch(`${API}/auth/google`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ code, redirect_uri: redirectUri })
        });

        if (response.ok) {
          const userData = await response.json();
          setUserData(userData);
          
          const selectedPkg = localStorage.getItem('selected_package');
          if (selectedPkg) {
            window.history.replaceState(null, '', '/pricing');
            navigate('/pricing', { replace: true, state: { user: userData } });
          } else {
            // Clear query params and navigate to dashboard
            window.history.replaceState(null, '', '/dashboard');
            navigate('/dashboard', { replace: true, state: { user: userData } });
          }
        } else {
          console.error('Google auth exchange failed');
          navigate('/');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate, setUserData]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#080B14' }}>
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-400">Authenticating...</p>
      </div>
    </div>
  );
}
